import React, { useEffect, useState } from 'react';
import { Card, List, Tag, Badge, Empty, Typography, Button } from 'antd';
import { CalendarOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getLeaveRecords } from '../../api/leaves';

const { Text } = Typography;
const PAGE_SIZE = 5;

const TYPE_LABELS = {
  dogum_izni: 'Doğum İzni',
  yillik_izin: 'Yıllık İzin',
  mazeret_izni: 'Mazeret İzni',
  yarim_gun: 'Yarım Gün',
};

const LeaveRequestsPendingPanel = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, pageSize: PAGE_SIZE, total: 0 });

  const fetchItems = (page = 1) => {
    setLoading(true);
    getLeaveRecords({ status: 'pending', page, per_page: PAGE_SIZE })
      .then((res) => {
        setItems(res.data.data);
        setPagination({
          current: res.data.current_page,
          pageSize: res.data.per_page,
          total: res.data.total,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchItems(1); }, []);

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed((c) => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <CalendarOutlined style={{ color: '#1677ff' }} />
          İzin Talepleri — Bekleyen
          <Badge count={pagination.total} style={{ backgroundColor: pagination.total > 0 ? '#faad14' : '#d9d9d9' }} />
        </span>
      }
      style={{ marginBottom: 16 }}
    >
      {!collapsed && (
        <List
          size="small"
          loading={loading}
          dataSource={items}
          locale={{ emptyText: <Empty description="Bekleyen izin talebi yok." image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            size: 'small',
            hideOnSinglePage: true,
            onChange: (page) => fetchItems(page),
          }}
          renderItem={(item) => (
            <List.Item>
              <div className="w-full">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                  <Tag color="blue" style={{ margin: 0 }}>{TYPE_LABELS[item.type] || item.type}</Tag>
                  <Text type="secondary" className="text-xs">
                    {dayjs(item.start_at).format('DD.MM.YYYY HH:mm')} — {dayjs(item.end_at).format('DD.MM.YYYY HH:mm')}
                  </Text>
                </div>
                <div className="text-sm text-gray-700 mt-0.5">
                  {item.user ? (
                    <Button type="link" style={{ padding: 0, height: 'auto' }} onClick={() => navigate(`/users/${item.user.id}`)}>
                      {item.user.name} {item.user.surname}
                    </Button>
                  ) : '-'}
                </div>
              </div>
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default LeaveRequestsPendingPanel;
